export default {
  COUPON: "coupon",
  DIGITAL: "digital",
  PHYSICAL: "physical",
  MERCHANDISE: "merchandise",
  INSTANT: "instant",
  ONE_HOUR: "1h",
  COMPANY_BENEFIT: "company-benefit",
  APP_ONLY: "app-only",
  TIME_LIMIT_24_HOUR: "time-limit-24-hours",
  SHIPPING_INCLUDED: "shipping-included"
}
